import React from 'react';
import {Trash} from '../../assets/icons/icons';
import {BadgeImage, BadgeHidden, BadgeImageContainer, BadgeImageDelete, BadgeImageDeleteText} from './styles';
import DefaultLogo from '../../assets/icons/defaultAvatar.png';

export default ({srcImage = DefaultLogo, size, callback}: {srcImage: string | any; size?: string; callback?: () => void}) => (
  <BadgeImageContainer>
    <BadgeImage src={srcImage === 'null' ? DefaultLogo : srcImage} size={size} />
    {srcImage === 'null' ? (
      <></>
    ) : (
      <BadgeHidden>
        <BadgeImageDelete onClick={callback}>
          <Trash />
          <BadgeImageDeleteText>Delete</BadgeImageDeleteText>
        </BadgeImageDelete>
      </BadgeHidden>
    )}
  </BadgeImageContainer>
);
